/*
 * @Descripttion: types
 * @Author: juanjuanhui
 * @Date: 2021-08-06 14:26:00
 * @LastEditors: quwandong
 * @LastEditTime: 2022-07-07 14:22:21
 */
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN";
